import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("cd3164b4a3", ".ca605c9335af4c37__wrapper{color:var(--wp-components-color-foreground,currentColor)}");
}
export default {"wrapper":"ca605c9335af4c37__wrapper"};
